// A callback function called upon event
export const onAccountConnectedCallBack = (
  accountId,
  workplatformId,
  userId
) => {
  console.log(
    `onAccountConnected accountId: ${accountId}, workplatformId: ${workplatformId}, userId: ${userId}`
  );
};
export const onAccountDisconnectedCallBack = (
  accountId,
  workplatformId,
  userId
) => {
  console.log(
    `onAccountDisconnected accountId: ${accountId}, workplatformId: ${workplatformId}, userId: ${userId}`
  );
};
export const onTokenExpiredCallBack = (userId) => {
  console.log(`onTokenExpired userId: ${userId}`);
};
